/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../../common/constants';
import en from '../../../../common/languages/en';
import utils from '../../../../common/utils';

export default class AddTenantFeatureService extends BaseService {
  constructor() {
    super(constants.ADD_TENANT_FEATURE_DATA, 'addTenantFeatureStatus');
  }

  handleEvent(eventName, event) {
    const headers = utils.buildHeadersWithTenantId(event);
    return this.getClient('aiadmin').post(`/aiadmin/tenant/feature/add`, event.payload, { headers });
  }

  handleResponse(response) {
    const { data } = response;

    if (data?.success === false) {
      const notification = {
        open: true,
        type: 'info',
        message: data?.message || en['tenantFeature.DUPLICATE_KEY']
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getEventManager().publish(constants.TENANT_FEATURE_ADD_FAILED);
      return;
    }

    Framework.getStoreRegistry().getStore('tenantFeature').setAddedTenantFeature(response);
    const notification = {
      open: true,
      type: 'success',
      message: data?.message || en['tenantFeature.ADD_SUCCESS']
    };
    Framework.getStoreRegistry().getStore('notificationState').set(notification);
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data) {
        const notification = {
          open: true,
          message: data?.message || en['tenantFeature.ADD_ERROR'],
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
